import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black px-4 pb-28 pt-8 text-center text-white/60" data-id="element-149" data-mp="19ivlq3plplne">
      <p className="text-sm font-semibold" data-id="element-150" data-mp="206rhpe6t9mr6">© 2026 Dr. Sarah Collins — SMILE DESIGN ROADMAP™. All Rights Reserved.</p>
      <p className="mx-auto mt-3 max-w-2xl text-xs leading-relaxed" data-id="element-151" data-mp="2f421datlxyxz">
        Professional educational material. Not a substitute for clinical training, patient-specific diagnosis, independent professional judgment, or applicable standards of care.
      </p>
    </footer>;
}